module.exports = __webpack_public_path__ + "ic-campaign-center.svg?9b764a8937141befa13624f9308e2c39";